import { api } from '@smena/ui';

// Вендорские правила «агент сюда не пишет»: служебные боты мессенджеров, общие для всех УК.
// Клиентские правила заводит сама УК в панели - сюда они не попадают.

export interface VendorIgnoredRule {
  id: string;
  channel: string;
  kind: string;
  ref: string;
  note: string | null;
  createdBy: string | null;
  createdAt: string;
}

export function fetchVendorIgnored(): Promise<{ items: VendorIgnoredRule[] }> {
  return api('/api/admin/ignored-chats');
}

export function addVendorIgnored(input: {
  channel: string;
  kind: string;
  ref: string;
  note?: string;
}): Promise<{ id: string }> {
  return api('/api/admin/ignored-chats', { method: 'POST', json: input });
}

export function removeVendorIgnored(id: string): Promise<{ ok: true }> {
  return api(`/api/admin/ignored-chats/${id}`, { method: 'DELETE' });
}
